export default __webpack_public_path__ + "media/images/front/municipality_collaboration/nishikan/ogp-895362ee9e220d6f18fd359175c3d438.jpg";